<script>
export default {
  computed: {
    canDownload: function() {
      const isOwner = (this.$store.state?.user?.id === this.$store.state?.item?.relationships?.user?.data?.id === true);
      const orgAllows = this.$store.state?.item?.attributes?.download_enabled;

      return (isOwner || orgAllows);
    }
  }
}
</script>
